import { Box } from "@mui/material";
import { UserInfo } from "../../../types";
import UserCard, { UserCardSkeleton } from "../UserCard";
import NoFilteringResultsFigure from "../NoFilteringResultsFigure";
import NoConnectionsFigure from "../NoConnectionsFigure";

interface NetworkListingProps {
  isNetworkDataLoading: boolean;
  networkData: any[];
  hasActiveFilters: boolean;
  compareData: any;
  checkCompareSelection: (value: any) => void;
}

const NetworkListing = ({
  isNetworkDataLoading,
  networkData,
  hasActiveFilters,
  compareData,
  checkCompareSelection,
}: NetworkListingProps) => {
  return (
    <Box
      sx={{
        minHeight: "50vh",
        columnGap: "9px",
        rowGap: "13px",
        display: "grid",
        gridTemplateColumns: { xs: "repeat(2, calc(50% - 4.5px))", sm: "repeat(3, calc(33.33% - 6px))" },
      }}
    >
      {isNetworkDataLoading && [...Array(6)].map((_, idx) => <UserCardSkeleton key={idx} />)}
      {!isNetworkDataLoading && networkData.length === 0 ? (
        !isNetworkDataLoading && hasActiveFilters ? (
          <NoFilteringResultsFigure />
        ) : (
          <NoConnectionsFigure />
        )
      ) : (
        networkData.map((value: UserInfo, index: number) => {
          return (
            <UserCard
              key={value.id + index}
              compareData={compareData}
              checkCompareSelection={checkCompareSelection}
              data={value}
            />
          );
        })
      )}
    </Box>
  );
};

export default NetworkListing;
